export default "__VITE_PUBLIC_ASSET__f8a39ffd__"